/**
 *
 * @Author:zbb
 * @Date : 2020/8/18
 *
 * 定义公共UI组件，包括alert tipInfo confirm loading 等等
 *
 * 基于elementUI封装 常规界面元素
 *
 * 使用方式：
 *   this.$UI.notify(xxxx);
 *   this.$UI.alert(xxxx);
 *   this.$UI.confirm(xxxx,()=>{},()=>{});
 *   this.$UI.loadModule(url,()=>{});
 *   this.$UI.loading();
 **/
// let loading;


class UI {
  constructor(Vue) {
    this.vue = new Vue();
  }

  /**
   * 成功通知
   */
  // notify(message, cb) {
  //   this.vue.$message({
  //     showClose: true,
  //     message: message ? message : '操作成功',
  //     type: 'success'
  //   });
  //   if (cb) {
  //     setTimeout(() => {
  //       cb && cb();
  //     }, 2000)
  //   }
  // }


  notify(message, cb) {
    this.vue.$toast({
      message: message ? message : '操作成功',
      type: 'success',
      onClose: () => {
        cb && cb();
      }


    })

  }


  /**
   * 错误通知
   */
  // alert(message, cb) {
  //   this.vue.$alert(message, '提示', {
  //     dangerouslyUseHTMLString: true,
  //     confirmButtonText: "确定",
  //     type: "error",
  //     callback: () => {
  //       cb && cb();
  //     }
  //   })
  // }



  alert(message, cb) {
    this.vue.$notify({
      message: message,
      type: 'danger',
      onClose: () => {
        cb && cb();
      }
    })


  }






  /**
   * 正确通知
   */
  // alertSuccess(message, cb) {
  //   this.vue.$alert(message, '提示', {
  //     dangerouslyUseHTMLString: true,
  //     confirmButtonText: "确定",
  //     type: "success",
  //     callback: () => {
  //       if (cb) {
  //         cb && cb();
  //       }
  //     }
  //   });
  // }


  alertSuccess(message, cb) {
    this.vue.$notify({
      message: message,
      type: 'success',
      onClose: () => {
        cb && cb();
      }

    })

  }






  /**
   * 确认对话框
   */
  // confirm(message, yesCallBack, noCallBack) {
  //   this.vue.$confirm(message, '提示', {
  //     confirmButtonText: '确定',
  //     cancelButtonText: '取消',
  //     type: 'warning'
  //   }).then(() => {
  //     yesCallBack && yesCallBack();
  //   }).catch(() => {
  //     noCallBack && noCallBack();
  //   })
  // }

  confirm(title, message, yesCallBack, noCallBack) {
    this.vue.$dialog.confirm({
      title: title,
      message: message,
      showCancelButton: true
    }).then(() => {
      yesCallBack && yesCallBack();
    }).catch(() => {
      noCallBack && noCallBack();
    })

  }




  /**
   * 加载
   */
  // loading(sts) {
  //   if (sts !== false) {
  //     loading = this.vue.$loading({
  //       lock: true,
  //       text: '虽然我很用劲，奈何网络不给力，拼命加载中。。。',
  //       spinner: 'el-icon-loading',
  //       background: 'rgba(0, 0, 0, 0.7)'
  //     });


  //     setTimeout(() => {
  //       loading.close();
  //     }, 1000 * 10);
  //   } else {
  //     loading.close();
  //   }
  // }



  loading(sts = true) {
    if (sts) {
      this.vue.$toast.loading({
        message: '虽然我很用劲，奈何网络不给力，拼命加载中。。。',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 10000 //值为0时不关闭
      })
    } else {
      this.vue.$toast.clear();
    }

  }


  /**
   * 刷新
   */
  refresh() {
    setTimeout(() => {
      this.vue.$EventBus.$emit("refresh");
    }, 1500)

  }


  /**
   * 消息推送
   */
  // msgPush(title, message, cb) {
  //   this.vue.$notify({
  //     title,
  //     message,
  //     type: 'success',
  //     duration: 0,
  //     onClick: () => {
  //       cb && cb();
  //     }
  //   });
  // }






}

export default UI;



//////////////////
// WEBPACK FOOTER
// ./src/tool/ui.js
// module id = 2NaB
// module chunks = 10